import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FilePreviewUtil } from '../../../utils/candidate/file-preview-util';

@Component({
  selector: 'app-file-preview-dialog',
  templateUrl: './file-preview-dialog.component.html',
  styleUrls: ['./file-preview-dialog.component.scss']
})
export class FilePreviewDialogComponent {
  src: any;
  constructor(public dialogRef: MatDialogRef<FilePreviewDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private filePreviewUtil: FilePreviewUtil) {
    this.src = this.filePreviewUtil.convertBase64ToArrayBuffer(data.filesrc);
  }

  // closes the dialog
  onCancel(): void {
    this.dialogRef.close();
  }
}